<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: currentPage.images.oImage1.text,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>
                <div class="container-components mb-4 lg:mb-8">
                    <div class="card" style="padding-top: 0;">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <p
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></p>
                        </TitleParagraph>
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content.text
                            "
                        ></span>
                        <!-- <Dots
                            :options="{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                            }"
                        /> -->
                    </div>
                    <div class="card">
                        <div class="relative">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `Paimpol Bréhat : projet de démonstrateur hydrolien`
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                            <image-with-descriptions
                                class="mb-4"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage2
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphThree_Content.text
                            "
                        ></p>
                    </div>
                </div>

                <div>
                    <image-with-descriptions
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage3.src,
                            descriptions: [
                                {
                                    text: currentPage.images.oImage3.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                </div>
                <div class="container-components mt-8">
                    <div class="card" style="padding-top:0;">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Title
                                        .text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'up',
                                }"
                            />
                        </TitleParagraph>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Content
                                        .text
                                "
                            ></span>

                            <!-- <square
                                :options="{
                                    from: 'from-feijoa',
                                    to: 'to-selective_green',
                                }"
                            /> -->
                        </paragraph>
                        <div class="relative">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `De l'hydrogène et du soleil pour la traite des vaches du Beaufortain`
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                            <image-with-descriptions
                                class="pb-4"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage4
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                        <article-note
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage5.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                                verticalcontent:
                                    currentPage.content.sParagraphFive_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphFive_Quote
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-2xl 2xl:text-3xl',
                                    content: '',
                                },
                                margin: {},
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";
import ArticleNote from "../../components/ArticleNote.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        ArticleNote,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
